import { Routes } from '@angular/router';
import { ScheduleInterviewComponent } from './schedule-interview.component';
import { SelectTimeComponent } from './select-time/select-time.component';
import { SelectDateComponent } from './select-date/select-date.component';
import { SelectLocationComponent } from './select-location/select-location.component';
import { ReviewSubmitComponent } from './review-submit/review-submit.component';
import { SelectLocationGuard } from './select-location/select-location.guard';
import { SelectDateGuard } from './select-date/select-date.guard';
import { SelectTimeGuard } from './select-time/select-time.guard';
import { ReviewSubmitGuard } from './review-submit/review-submit.guard';
import { ScheduleRemoteGuard } from './schedule-remote/schedule-remote.guard';
import { ScheduleRemoteComponent } from './schedule-remote/schedule-remote.component';

export const ScheduleInterviewRoutes: Routes = [
    {
        path: 'schedule-interview',
        component: ScheduleInterviewComponent,
        children: [
            {
                path: 'location',
                canActivate: [SelectLocationGuard],
                component: SelectLocationComponent,
                data: { title: 'SCHEDULE_INTERVIEW.LOCATION.TITLE'}
            },
            {
                path: 'date',
                canActivate: [SelectDateGuard],
                component: SelectDateComponent,
                data: { title: 'SCHEDULE_INTERVIEW.DATE.TITLE'}
            },
            {
                path: 'time',
                canActivate: [SelectTimeGuard],
                component: SelectTimeComponent,
                data: { title: 'SCHEDULE_INTERVIEW.TIME.TITLE'}
            },
            {
                path: 'review-submit',
                canActivate: [ReviewSubmitGuard],
                component: ReviewSubmitComponent,
                data: { title: 'SCHEDULE_INTERVIEW.REVIEW.TITLE'}
            },
            {
                path: 'schedule-remote',
                canActivate: [ScheduleRemoteGuard],
                component: ScheduleRemoteComponent
            }

        ]
    }
];
